import React from 'react';
import ReactDOM from 'react-dom/client';

// Import all CSS styles through barrel file
import './styles';
import reportWebVitals from './shared/utils/reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './appRoutes';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <omni-style accessible>
        <AppRoutes />
      </omni-style>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
